<div class="dialog-container">
  <div
    mat-dialog-title
    class="close-div"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle
  >
    <h4>{{ dialogTitle }}</h4>
    <div class="title-actions">
      <button
        mat-button
        [mat-dialog-close]=""
        (click)="onClose()"
        cdkFocusInitial
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
  <div mat-dialog-content class="update-review dialog-content">
    <h4 class="sectionTitle">{{ sectionTitle }}</h4>
    <div class="para">
      <div>Question: <span [innerHTML]="newQuestion"></span></div>
    </div>
    @if (data.content.answerDropped) {
    <div class="answer-dropped-note">
      @if (isNewQuestion) {
      This is a new applicability question. Please review and answer it.
      } @else {
      Your previous answer to this question was cleared because it changed
      significantly. Please review and answer it again.
      }
    </div>
    }
    @if (data.content.exemptionChanged) {
    <div class="para">
      <div>Exemption: <span [innerHTML]="newExemption"></span></div>
    </div>
    @if (data.content.exemptionAnswerDropped) {
    <div class="answer-dropped-note">
      @if (isNewExemption) {
      This is a new exemption for this question. If you answer Yes to the
      question, please review and answer the exemption.
      } @else {
      Your previous answer to this exemption was cleared because it changed
      significantly. If you answer Yes to the question, please review and
      answer the exemption again.
      }
    </div>
    }
    }
  </div>
  <div mat-dialog-actions>
    <div>
      <button
        mat-button
        (click)="onClose()"
        mat-dialog-close
        class="button-close"
        cdkFocusInitial
      >
        Close
      </button>
    </div>
  </div>
</div>
